import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { RISK_ANALYSIS_LAYER_LIST } from '../const/map_config'

// スタイル定義
const formControlStyle = {
  '& .MuiOutlinedInput-root': {
    color: 'white',

    '& fieldset': {
      borderColor: 'white',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: 'white',
      borderWidth: '1px',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
      borderWidth: '1px',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'white',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white',
  },
};

const selectStyle = {
  color: 'white',
  textAlign: 'center',
  '& .MuiSelect-select': {
    textAlign: 'center',
  },
  '& svg': {
    color: 'white',
  },
};

const menuPaperProps = {
  sx: {
    backgroundColor: 'black',
    color: 'white',
  },
};

const RiskAnalysisSelectMenus = (props) => {

  const handleChange = (event) => {
    props.setSelectLayer(
      RISK_ANALYSIS_LAYER_LIST.find(layer => layer.category === event.target.value));
  };

  return (
    <FormControl fullWidth sx={formControlStyle} size="small" >
      <InputLabel id="custom-select-label"></InputLabel>
      <Select
        labelId="custom-select-label"
        value={props.selectLayer}
        onChange={handleChange}
        sx={selectStyle}
        MenuProps={{
          PaperProps: menuPaperProps,
        }}
      >
        {RISK_ANALYSIS_LAYER_LIST.map((item) =>
          <MenuItem key={item.category} value={item.category}>
            {item.name}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default RiskAnalysisSelectMenus;
